jQuery(document).ready(function($){

  $(document).ready(function () {
      var $RelatedResources = $('.RelatedResources-feed-slider');
  
      if ( $RelatedResources ) {
          var RelatedResources = $RelatedResources;
  
  
          /* slider initialization */
          RelatedResources.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              cssEase: "linear",
              dots: true,
              arrows: false,
              responsive: [
                {
                  breakpoint: 4000,
                  settings: "unslick",
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
        
          ]
  
          });
  
      }
  });
  });